/**
 * Sprint T-17.1 · Notification Center · StatusPill.
 * Colored pill per DeliveryStatus (10 statuses).
 * §7.1 of design doc.
 */
import React from "react";
import {
  CheckCircle, CheckCheck, XCircle, Clock, UserX, Slash,
  Gauge, AlertOctagon, Eye, MousePointer,
} from "lucide-react";

const MAP = {
  sent:                  { label: "sent",             icon: CheckCircle,  cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" },
  delivered:             { label: "delivered",        icon: CheckCheck,   cls: "bg-emerald-600/20 text-emerald-500 border-emerald-500/40" },
  failed:                { label: "failed",           icon: XCircle,      cls: "bg-red-500/15 text-red-500 border-red-500/30" },
  queued:                { label: "queued",           icon: Clock,        cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  skipped_by_preference: { label: "skipped-pref",     icon: UserX,        cls: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
  skipped_no_provider:   { label: "no-provider",      icon: Slash,        cls: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
  rate_limited:          { label: "rate-limited",     icon: Gauge,        cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  invalid_template:      { label: "invalid-tpl",      icon: AlertOctagon, cls: "bg-orange-500/15 text-orange-500 border-orange-500/30" },
  opened:                { label: "opened",           icon: Eye,          cls: "bg-violet-500/15 text-violet-400 border-violet-500/30" },
  clicked:               { label: "clicked",          icon: MousePointer, cls: "bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30" },
};

export default function StatusPill({ status, testId, showIcon = true, size = "sm" }) {
  const s = (status || "queued").toLowerCase();
  const cfg = MAP[s] || MAP.queued;
  const Icon = cfg.icon;
  const paddings = size === "xs" ? "px-1 py-0.5 text-[9px]" : "px-1.5 py-0.5 text-[10px]";
  return (
    <span
      data-testid={testId || `status-pill-${s}`}
      className={`inline-flex items-center gap-1 rounded border font-mono uppercase tracking-wide ${paddings} ${cfg.cls}`}
      title={s}
    >
      {showIcon && Icon && <Icon className="h-2.5 w-2.5" />}
      {cfg.label}
    </span>
  );
}

export const ALL_DELIVERY_STATUSES = Object.keys(MAP);
